var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"id":"ts-element-input"},nativeOn:{"autoNumeric:rawValueModified":function($event){return _vm.updateVModel($event)},"autoNumeric:initialized":function($event){return _vm.initialized($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }